import dayjs from 'dayjs';

const dateTimeParser = (date) => {
  if (date) {
    return dayjs(date).format('DD MMMM YYYY, HH:mm');
  }
  return '';
};

export default dateTimeParser;
